import type { CreateSavedViewPayload } from '@domain/schemas/payload.schema';
import type { SavedViewResponse } from '@domain/schemas/saved-view.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

export const createSavedView = async (data: CreateSavedViewPayload): Promise<SavedViewResponse> => {
  const networkPayload = await getRequestAuthPayload({ method: 'post', url: 'saved-views', data });
  const response = await axios(networkPayload);
  return response.data;
};
